// Ayati Constructions - Real Project Data from Company Profile

export const companyInfo = {
  name: "Ayati Constructions and Estates LLP",
  tagline: "Building Excellence in India's Skyline",
  description: "Leading construction contractors specializing in high-rise buildings, delivering excellence in every project through innovation, quality, and precision.",
  rating: 4.5,
  reviewCount: 100,
  phone: "040-48581579",
  email: "info@ayaticonstructions.com",
  address: "Plot No 18, Sy. No. 197, 198 and 199 (Parts), Kondapur",
  location: "Serilingampally, Hyderabad, 500084",
  coordinates: {
    lat: 17.4793,
    lng: 78.3594
  },
  founded: "17th January 2020",
  taglineGreen: "As Green as Mother Nature",
  aboutUs: `AYATI Constructions and Estates LLP (Ayati) is the brainchild of a visionary real estate professional Mr. KVK Raju who has honed his skills in all the spheres of construction industry. The journey of Ayati has started on 17th January 2020. The company is driven to deliver the projects on time with advanced construction practices, engineering expertise and management techniques with an uncompromising standard on quality, safety and having sustainability as an integral part of approach to business and work practices.

World-class properties are not simply built. They are made world-class every day by the people who manage and maintain them. Ayati's experienced management and professionals work tirelessly to serve our clients and deliver the product to the highest possible standards.

With 200+ Professionals and immense workmen force forms the backbone of Ayati. The team consists of Engineering team supported with Quality, Safety and MEP services teams.`,
  mission: "To build with uncompromising quality and unwavering integrity — every project, every promise.",
  vision: "To be India's most trusted construction partner — shaping skylines with quality and integrity.",
  values: [
    {
      title: "Ethics",
      description: "Integrity in every decision, transparency in every deal."
    },
    {
      title: "Safety",
      description: "Zero-accident sites, healthy people, protected workmanship."
    },
    {
      title: "Quality",
      description: "Built right the first time — no shortcuts, no compromise."
    },
    {
      title: "Sustainability",
      description: "Responsible building for the planet, people, and future generations."
    },
    {
      title: "Diversity & Inclusion",
      description: "Equal opportunity, every voice, every talent — welcomed and heard."
    },
    {
      title: "Innovation",
      description: "Adopting new-age techniques and technology to build smarter."
    },
    {
      title: "Commitment",
      description: "We do what we say — and go a step beyond, every time."
    },
    {
      title: "Client Partnership",
      description: "Open communication, shared goals, lasting relationships."
    }
  ],
  leadership: [
    {
      name: "Kanumuri Venkata Krishnam Raju (KVK)",
      position: "Managing Partner",
      qualification: "B.E (Civil), MRICS",
      experience: "30 years of professional experience in residential real estate projects in various cities majorly in Hyderabad, Bangalore, and Vijayawada. Started his career in 1995 as GET in NCC and reached to the level of Executive Vice President in Aparna Constructions by the year 2019."
    },
    {
      name: "G Satish Babu",
      position: "Vice President",
      qualification: "B.Tech (Civil)",
      experience: "20 years of experience in construction industry having handled areas of operations, revenue, profitability and growth, business development and project management."
    },
    {
      name: "T Sunil Reddy",
      position: "General Manager",
      qualification: "",
      experience: "Over 20 years of experience in real estate sector and leads the HR and Admin departments in the organisation."
    },
    {
      name: "D Lakshmipathi Raju",
      position: "Assistant General Manager",
      qualification: "B.Tech (Civil), MBA in Construction Economics",
      experience: "9 years of experience and had previously worked with L&T and JLL. Heads the Planning and QS department in the company."
    }
  ],
  teamSize: "200+ Professionals"
};

export const services = [
  {
    id: 1,
    title: "High-Rise Construction",
    description: "Specialized expertise in constructing modern high-rise buildings with advanced engineering techniques including Mivan formwork and safety standards.",
    icon: "Building2",
    features: ["Multi-story Buildings", "Mivan Formwork", "Safety Compliance", "Quality Assurance"]
  },
  {
    id: 2,
    title: "Commercial Construction",
    description: "End-to-end construction services for commercial complexes, corporate office buildings, and industrial facilities.",
    icon: "Briefcase",
    features: ["Corporate Offices", "Industrial Buildings", "Commercial Complexes", "Turnkey Projects"]
  },
  {
    id: 3,
    title: "Residential Construction",
    description: "Quality residential construction services for apartments, villas, and gated communities with premium finishes.",
    icon: "Home",
    features: ["Apartment Buildings", "Luxury Villas", "Gated Communities", "Custom Homes"]
  },
  {
    id: 4,
    title: "MEP Works",
    description: "Comprehensive Mechanical, Electrical, and Plumbing services integrated into all our construction projects.",
    icon: "HardHat",
    features: ["Electrical Systems", "Plumbing", "HVAC", "Fire Safety"]
  },
  {
    id: 5,
    title: "Structural Works",
    description: "Expert structural engineering including core-structure, block work, plastering, and waterproofing works.",
    icon: "ClipboardCheck",
    features: ["Core Structure", "Block Work", "Plastering", "Waterproofing"]
  },
  {
    id: 6,
    title: "Project Management",
    description: "Professional project management ensuring timely completion, budget adherence, and quality standards.",
    icon: "Users",
    features: ["Timeline Management", "Budget Control", "Quality Monitoring", "Stakeholder Coordination"]
  }
];

// Completed Projects - Using actual images from PDF
export const completedProjects = [
  {
    id: 1,
    title: "Aparna Cyberscape",
    category: "Residential High-Rise",
    description: "Project completed within 3 years including structure, finishing and MEP works. 4 blocks with premium apartments.",
    image: "/projects/aparna_cyberscape.jpeg",
    details: {
      client: "Aparna Constructions and Estates Pvt. Ltd.",
      blocks: "4 Blocks (A, B, C, D)",
      floors: "2 Basements + Stilt + 22 Floors",
      apartments: "612 Flats",
      siteArea: "5.5 Acres",
      builtUpArea: "13,39,872 Sft",
      projectValue: "104 Crores",
      scopeOfWork: "Core-structure, Block work, Plastering, Waterproofing, Metal works, External painting and MEP Works",
      startDate: "1st March 2020",
      endDate: "22nd March 2023",
      status: "Completed",
      year: "2023"
    }
  },
  {
    id: 2,
    title: "LSI Factory - Sultanpur",
    category: "Industrial",
    description: "Factory project completed within 8 months including structure, finishing and MEP works.",
    image: "/projects/lsi_factory.jpeg",
    details: {
      client: "Lyophilization Systems India Pvt. Ltd",
      blocks: "1 Building",
      floors: "1 Basement + Ground + 2 Mezzanine Floors",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "75,254 Sft",
      projectValue: "8.89 Crores",
      scopeOfWork: "Structure, Compound wall, Block work, Plastering and CRS works, MEP Works",
      startDate: "18th Feb 2021",
      endDate: "16th Oct 2021",
      status: "Completed",
      year: "2021",
      location: "Sultanpur"
    }
  },
  {
    id: 3,
    title: "IRA Miracle",
    category: "Residential High-Rise",
    description: "Project completed within 2.5 years including structure, finishing and MEP works. 3 residential blocks.",
    image: "/projects/ira_miracle.jpeg",
    details: {
      client: "IRA Realty Tech Pvt. Ltd.",
      blocks: "3 Blocks (A, B, C)",
      floors: "2 Basements + Ground Floor + 14 Floors",
      apartments: "274 Flats",
      siteArea: "3 Acres",
      builtUpArea: "7,79,263 Sft",
      projectValue: "52 Crores (Shell & core)",
      scopeOfWork: "Core-structure, Block work, Plastering, Waterproofing works, MEP Works",
      startDate: "17th August 2021",
      endDate: "16th Feb 2024",
      status: "Completed",
      year: "2024"
    }
  },
  {
    id: 4,
    title: "Solitaire Unity",
    category: "Residential High-Rise",
    description: "Core-structure, Block work, Plastering, Waterproofing works, MEP works and VDF works.",
    image: "/projects/solitaire_unity.jpeg",
    details: {
      client: "Technopolis Constructions Pvt. Ltd.",
      blocks: "1 Block",
      floors: "3 Basements + Ground Floor + 18 Floors",
      apartments: "396 Units",
      siteArea: "3 Acres",
      builtUpArea: "8,96,875 Sft",
      projectValue: "52 Crores (Shell & core)",
      scopeOfWork: "Core-structure, Block work, Plastering, Waterproofing works, MEP works and VDF works",
      startDate: "28th Dec 2021",
      endDate: "December 2024",
      status: "Completed",
      year: "2024"
    }
  },
  {
    id: 5,
    title: "Nyla Project",
    category: "Residential High-Rise",
    description: "Core-structure (Mivan), VDF Works, MEP works for 3 high-rise residential blocks.",
    image: "/projects/nyla_project.jpeg",
    details: {
      client: "Team4 Life Spaces",
      blocks: "3 Blocks (A, B, C)",
      floors: "3 Basements + 2 Stilts + 35 Floors",
      apartments: "945 Units",
      siteArea: "6 Acres",
      builtUpArea: "21,80,800 Sft",
      projectValue: "75.5 Crores (Shell & core)",
      scopeOfWork: "Core-structure (Mivan), VDF Works, MEP works",
      startDate: "18th Feb 2022",
      endDate: "January 2025",
      status: "Completed",
      year: "2025"
    }
  },
  {
    id: 6,
    title: "Myra Villas",
    category: "Residential Villas",
    description: "Premium villa community with 94 luxury villas featuring core-structure, block work, plastering, and waterproofing.",
    image: "/projects/myra_villas.jpeg",
    details: {
      client: "Indis Villa Development Pvt. Ltd.",
      blocks: "94 Villas",
      floors: "Ground + 2 Floors",
      apartments: "94 Villas",
      siteArea: "8.1 Acres",
      builtUpArea: "3,51,197 Sft",
      projectValue: "55 Crores (Shell & core)",
      scopeOfWork: "Core-structure, Block work, Plastering, Waterproofing, and Metal works",
      startDate: "18th Jan 2023",
      endDate: "April 2025",
      status: "Completed",
      year: "2025"
    }
  },
  {
    id: 7,
    title: "Chidrupi Towers",
    category: "Residential High-Rise",
    description: "Core-structure using Mivan technology with waterproofing works for premium residential tower.",
    image: "/projects/chidrupi_towers.jpeg",
    details: {
      client: "Chidrupi Financial Services Ltd.",
      blocks: "1 Block",
      floors: "2 Basements + Ground Floor + 14 Floors",
      apartments: "230 Units",
      siteArea: "2 Acres",
      builtUpArea: "4,76,643 Sft",
      projectValue: "38 Crores (Shell & core)",
      scopeOfWork: "Core-structure (Mivan), Waterproofing works",
      startDate: "01 Feb 2023",
      endDate: "March 2025",
      status: "Completed",
      year: "2025"
    }
  },
  {
    id: 8,
    title: "KIMS Savera - Ananthapur",
    category: "Healthcare",
    description: "Healthcare facility with structural works and retaining wall for KIMS Hospital.",
    image: "/projects/kims_savera.jpeg",
    details: {
      client: "KIMS",
      blocks: "1 Building + Addition",
      floors: "2 Basements + GF + 5 Floors (Added 2 Floors to Existing)",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "2,06,096 Sft",
      projectValue: "19 Crores",
      scopeOfWork: "Structural Works and Retaining wall",
      startDate: "2nd Nov 2023",
      endDate: "March 2025",
      status: "Completed",
      year: "2025",
      location: "Ananthapur"
    }
  },
  {
    id: 9,
    title: "Karbonn Corporate Office",
    category: "Commercial",
    description: "Modern corporate office building with contemporary glass facade and premium finishes.",
    image: "/projects/karbonn_office.jpeg",
    details: {
      client: "UTI Links (Bangalore) Pvt. Ltd.",
      blocks: "1 Building",
      floors: "3 Basements + Stilt + 6 Office Floors",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "2,50,000 Sft",
      projectValue: "33.18 Crores (Shell & core)",
      scopeOfWork: "Core-structure, Block work, Plastering, Waterproofing, Metal works",
      startDate: "31st Dec 2023",
      endDate: "March 2025",
      status: "Completed",
      year: "2025"
    }
  }
];

// Ongoing Projects - Using actual images from PDF
export const ongoingProjects = [
  {
    id: 10,
    title: "Twin Towers",
    category: "Luxury High-Rise",
    description: "Core-structure (Mivan), VDF Works, MEP works for twin tower luxury development.",
    image: "/projects/twin_towers.jpeg",
    details: {
      client: "DSR SSI Builders Pvt. Ltd.",
      blocks: "2 Blocks (A, B)",
      floors: "4 Basements + 2 Stilts + 41 Floors",
      apartments: "82 Units",
      siteArea: "3.5 Acres",
      builtUpArea: "14,50,800 Sft",
      projectValue: "78 Crores (Shell & core)",
      scopeOfWork: "Core-structure (Mivan), VDF Works, MEP works",
      startDate: "2nd Sep 2022",
      currentStatus: "A Block 39th Floor Roof slab and B Block 42nd Floor roof slab Work in progress",
      status: "Ongoing",
      year: "2022-Present"
    }
  },
  {
    id: 11,
    title: "ACASA - Kokapet",
    category: "Residential High-Rise",
    description: "Core-structure (Mivan), VDF Works for premium residential building in Kokapet.",
    image: "/projects/acasa.jpeg",
    details: {
      client: "Simchah Estates Pvt. Ltd.",
      blocks: "1 Block",
      floors: "4 Basements + Ground Floor + 35 Floors",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "5,41,071 Sft",
      projectValue: "23 Crores (Shell & core)",
      scopeOfWork: "Core-structure (Mivan), VDF Works",
      startDate: "9th Aug 2023",
      currentStatus: "23rd Floor Roof Slab work in progress",
      status: "Ongoing",
      year: "2023-Present",
      location: "Kokapet, Hyderabad"
    }
  },
  {
    id: 12,
    title: "Jayabheri Pinnacle",
    category: "Luxury High-Rise",
    description: "Iconic twin tower project with 55 floors using Mivan core-structure technology.",
    image: "/projects/jayabheri_pinnacle.jpeg",
    details: {
      client: "M/s. Jayabheri Projects Pvt. Ltd.",
      blocks: "2 Blocks (A, B)",
      floors: "4 Basements + 2 Stilts + 55 Floors",
      apartments: "440 Units",
      siteArea: "3.5 Acres",
      builtUpArea: "21,93,262 Sft",
      projectValue: "106 Crores (Shell & core)",
      scopeOfWork: "Core-structure (Mivan)",
      startDate: "25th Nov 2023",
      currentStatus: "Tower A 30th Floor Roof Slab and Tower B 25th Floor Roof Slab Work in progress",
      status: "Ongoing",
      year: "2023-Present"
    }
  },
  {
    id: 13,
    title: "Rajapushpa Casa Luxura (Neopolis)",
    category: "Luxury High-Rise",
    description: "Massive 5-block premium residential project using Mivan core-structure technology.",
    image: "/projects/rajapushpa_neopolis.jpeg",
    details: {
      client: "Rajapushpa Properties",
      blocks: "5 Blocks (A, B, C, D, E)",
      floors: "4 Basements + 1 Stilt + 51 Floors",
      apartments: "612 Units",
      siteArea: "7.7 Acres",
      builtUpArea: "52,67,164 Sft",
      projectValue: "195 Crores (Shell and Core)",
      scopeOfWork: "Core-structure (Mivan)",
      startDate: "May 2024",
      currentStatus: "Podium and Basement structure work in Progress",
      status: "Ongoing",
      year: "2024-Present"
    }
  },
  {
    id: 14,
    title: "Vamsiram Manhattan 5th Avenue",
    category: "Luxury High-Rise",
    description: "4-block premium residential project with 51 floors using Mivan technology.",
    image: "/projects/vamsiram_manhattan.jpeg",
    details: {
      client: "Vamsiram Builders",
      blocks: "4 Blocks (A, B, C, D)",
      floors: "3 Basements + 4 Podiums + 51 Floors",
      apartments: "282 Units",
      siteArea: "7 Acres",
      builtUpArea: "42,54,654 Sft",
      projectValue: "173 Crores (Shell and Core)",
      scopeOfWork: "Core-structure (Mivan)",
      startDate: "8 Aug 2024",
      currentStatus: "Basement Structure work in progress",
      status: "Ongoing",
      year: "2024-Present"
    }
  },
  {
    id: 15,
    title: "Rajapushpa Infina",
    category: "Luxury High-Rise",
    description: "Mega project with 6 blocks and 53 floors - Ayati's largest ongoing project.",
    image: "/projects/rajapushpa_infina.jpeg",
    details: {
      client: "Rajapushpa Trustnest Reality LLP",
      blocks: "6 Blocks (A, B, C, D, E, F)",
      floors: "5 Basements + 1 Stilt + 53 Floors",
      apartments: "N/A",
      siteArea: "9 Acres",
      builtUpArea: "52,67,164 Sft",
      projectValue: "427 Crores (Shell and Core)",
      scopeOfWork: "Structure works",
      startDate: "Oct 2024",
      currentStatus: "Podium and Basement structure Work in Progress",
      status: "Ongoing",
      year: "2024-Present"
    }
  },
  {
    id: 16,
    title: "DSR Altitudes",
    category: "Residential High-Rise",
    description: "5-block residential project with barbending, aluminium form work, and Mivan/Plywood shuttering.",
    image: "/projects/dsr_altitudes.jpeg",
    details: {
      client: "DSR Builders & Developers",
      blocks: "5 Blocks (A, B, C, D, E)",
      floors: "3 Basements + 1 Stilt + 32 Floors",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "29,21,680 Sft",
      projectValue: "298 Crores (Shell and Core)",
      scopeOfWork: "Barbending, Aluminium Form work, Mivan/Plywood Shuttering and Concreting works",
      startDate: "11th Nov 2024",
      currentStatus: "Basements structure Work in Progress",
      status: "Ongoing",
      year: "2024-Present"
    }
  },
  {
    id: 17,
    title: "KIMS - Minister Road",
    category: "Healthcare",
    description: "Major healthcare facility expansion with structural works and retaining wall.",
    image: "/projects/kims_minister_road.jpeg",
    details: {
      client: "KIMS",
      blocks: "1 Building",
      floors: "2 Basements + GF + 14 Floors",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "4,87,415.448 Sft",
      projectValue: "77 Crores",
      scopeOfWork: "Structural Works and Retaining wall",
      startDate: "7th Nov 2024",
      currentStatus: "Basements structure Work in Progress",
      status: "Ongoing",
      year: "2024-Present",
      location: "Minister Road"
    }
  },
  {
    id: 18,
    title: "Fortune Waterfront",
    category: "Residential High-Rise",
    description: "2-block waterfront residential project with premium finishes.",
    image: "/projects/fortune_waterfront.jpeg",
    details: {
      client: "Sree Srinivasa Infra",
      blocks: "2 Blocks",
      floors: "3 Basements + 1 Stilt + 22 Floors",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "9,08,777 Sft",
      projectValue: "93 Crores (Shell and Core)",
      scopeOfWork: "Barbending, Aluminium Form work, Mivan/Plywood Shuttering and Concreting works",
      startDate: "Jan 2025",
      currentStatus: "Basement structure & Transfer slab works in Progress",
      status: "Ongoing",
      year: "2025-Present"
    }
  },
  {
    id: 19,
    title: "Yula Globus Neo",
    category: "Luxury High-Rise",
    description: "Ultra-tall 57-floor twin tower project with premium specifications.",
    image: "/projects/yula_globus_neo.jpeg",
    details: {
      client: "Yula Globus",
      blocks: "2 Blocks",
      floors: "5 Basements + Ground + 57 Floors",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "31,63,716 Sft",
      projectValue: "110.88 Crores (Shell and Core)",
      scopeOfWork: "Barbending, Aluminium Form work, Mivan/Plywood Shuttering and Concreting works",
      startDate: "Aug 2025",
      currentStatus: "Foundation works in Progress",
      status: "Ongoing",
      year: "2025-Present"
    }
  },
  {
    id: 20,
    title: "Brigade Citadel II & III",
    category: "Residential Complex",
    description: "Large-scale residential complex with comprehensive construction scope.",
    image: "/projects/brigade_citadel.jpeg",
    details: {
      client: "Brigade Enterprises Limited",
      blocks: "Citadel II: 3 Blocks, Citadel III: 4 Blocks",
      floors: "Citadel II: 2 Basements + Ground + 6 Floors, Citadel III: 1 Basement + Ground + 5 Floors",
      apartments: "N/A",
      siteArea: "N/A",
      builtUpArea: "12,88,089 Sft",
      projectValue: "228.91 Crores",
      scopeOfWork: "Excavation, Backfilling & WMM Filling, Dewatering, Plywood Shuttering, Concreting works, Masonry Works, Plastering Works, VDF Works, Joinery Works (Doors), Flooring works (Granite Stone & Tiles), Painting Works, False Ceiling Works and Water Proofing Works",
      startDate: "Dec 2025",
      currentStatus: "Commencement works in Progress",
      status: "Ongoing",
      year: "2025-Present"
    }
  },
  {
    id: 21,
    title: "Amara Villas",
    category: "Residential Villas",
    description: "Premium villa community with 42 luxury villas featuring comprehensive construction scope.",
    image: "/projects/amara_villas.jpeg",
    details: {
      client: "Indis Amara Villas",
      blocks: "42 Villas",
      floors: "Ground + 2 Floors",
      apartments: "42 Villas",
      siteArea: "N/A",
      builtUpArea: "3,51,197 Sft",
      projectValue: "35 Crores (Shell & core)",
      scopeOfWork: "Core-structure, Block work, Plastering, Waterproofing, and Metal works",
      startDate: "Jan 2026",
      currentStatus: "Commencement works in Progress",
      status: "Ongoing",
      year: "2026-Present"
    }
  }
];

// Combined projects array for backward compatibility
export const projects = [...completedProjects, ...ongoingProjects];

export const clients = [
  {
    id: 1,
    name: "Brigade Group",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/l5w356d8_WhatsApp%20Image%202026-02-02%20at%207.32.11%20PM%20%281%29.jpeg"
  },
  {
    id: 2,
    name: "Aparna Constructions",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/5yn2wpyp_WhatsApp%20Image%202026-02-02%20at%207.31.40%20PM%20%283%29.jpeg"
  },
  {
    id: 3,
    name: "Jayabheri Group",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/vg7mtdoj_WhatsApp%20Image%202026-02-02%20at%207.31.40%20PM%20%282%29.jpeg"
  },
  {
    id: 4,
    name: "KIMS Hospitals",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/4ov53mwr_WhatsApp%20Image%202026-02-02%20at%207.31.39%20PM%20%285%29.jpeg"
  },
  {
    id: 5,
    name: "Rajapushpa Properties",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/mqdfm0c1_WhatsApp%20Image%202026-02-02%20at%207.31.39%20PM%20%284%29.jpeg"
  },
  {
    id: 6,
    name: "Vamsiram Builders",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/x9efyw7u_WhatsApp%20Image%202026-02-02%20at%207.31.39%20PM%20%283%29.jpeg"
  },
  {
    id: 7,
    name: "Team4 Lifespaces",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/0h1s0afe_WhatsApp%20Image%202026-02-02%20at%207.31.37%20PM%20%285%29.jpeg"
  },
  {
    id: 8,
    name: "DSRSSI Builders",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/9k3kvzmb_WhatsApp%20Image%202026-02-02%20at%207.31.37%20PM%20%284%29.jpeg"
  },
  {
    id: 9,
    name: "Technopolis Construction",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/b33bmsku_WhatsApp%20Image%202026-02-02%20at%207.31.37%20PM%20%283%29.jpeg"
  },
  {
    id: 10,
    name: "IRA Realty",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/e0una4um_WhatsApp%20Image%202026-02-02%20at%207.31.36%20PM%20%281%29.jpeg"
  },
  {
    id: 11,
    name: "DSR Builders",
    logo: "https://customer-assets.emergentagent.com/job_854d447b-7e83-4ced-b39f-dd59af511e6b/artifacts/kqp6iorr_WhatsApp%20Image%202026-02-02%20at%207.31.38%20PM%20%281%29.jpeg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    role: "Project Manager, Tech Solutions",
    rating: 5,
    text: "Superb contracting company! Ayati Constructions delivered our office building ahead of schedule with exceptional quality. Their attention to detail and professionalism is unmatched.",
    image: "https://images.unsplash.com/photo-1742112125567-3e8967bad60f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjB0ZWFtfGVufDB8fHx8MTc2ODYzNTAxOHww&ixlib=rb-4.1.0&q=75&w=200"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Property Developer",
    rating: 5,
    text: "Good atmosphere for work and excellent coordination throughout the project. The team is highly skilled and responsive to all requirements.",
    image: "https://images.unsplash.com/photo-1742112125635-6f8201c6ee3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjB0ZWFtfGVufDB8fHx8MTc2ODYzNTAxOHww&ixlib=rb-4.1.0&q=75&w=200"
  },
  {
    id: 3,
    name: "Vikram Reddy",
    role: "Business Owner",
    rating: 4,
    text: "Very good office location and superb receiving people. Ayati Constructions handled our commercial complex construction with great expertise.",
    image: "https://images.pexels.com/photos/35571322/pexels-photo-35571322.jpeg"
  },
  {
    id: 4,
    name: "Anjali Mehta",
    role: "Residential Client",
    rating: 5,
    text: "Outstanding quality and timely delivery! The construction team was professional, and the final result exceeded our expectations.",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzfGVufDB8fHx8MTc2ODU3OTY3NHww&ixlib=rb-4.1.0&q=75&w=200"
  },
  {
    id: 5,
    name: "Suresh Patel",
    role: "Real Estate Consultant",
    rating: 5,
    text: "Reliable and trustworthy contractors. Their expertise in high-rise construction is evident in every project they undertake.",
    image: "https://images.unsplash.com/photo-1558227691-41ea78d1f631?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjB3b3JrZXJzfGVufDB8fHx8MTc2ODU3OTY3NHww&ixlib=rb-4.1.0&q=75&w=200"
  },
  {
    id: 6,
    name: "Mohammed Ali",
    role: "Architect",
    rating: 4,
    text: "Great collaboration and execution. Ayati's team understands complex architectural requirements and delivers precisely.",
    image: "https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg"
  }
];

export const stats = [
  { label: "Area Built", value: "2 Cr+", unit: "sq.ft", icon: "Ruler" },
  { label: "Projects Ongoing", value: "12+", icon: "Building" },
  { label: "Happy Clients", value: "15+", icon: "Users" },
  { label: "Expert Team", value: "200+", icon: "HardHat" }
];

export const whyChooseUs = [
  {
    title: "Expert Team",
    description: "200+ skilled professionals including engineers, architects, and construction specialists with Quality, Safety and MEP services teams",
    icon: "Users"
  },
  {
    title: "Quality Craftsmanship",
    description: "Commitment to excellence using advanced techniques like Mivan formwork, VDF works, and premium materials",
    icon: "CheckCircle"
  },
  {
    title: "Timely Delivery",
    description: "Proven track record of completing projects on time with advanced construction practices and engineering expertise",
    icon: "Clock"
  },
  {
    title: "Sustainability",
    description: "We act responsibly towards the planet, people, and communities in which we operate, integrating sustainable practices into every project",
    icon: "Leaf"
  }
];
